
import ConfirmationOverlay from './ConfirmationOverlay.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'IncorrectTrailerQrScanOverlay',
    components: {
        ConfirmationOverlay,
    },
    props: {
        attachingTrailerNumber: {
            type: String,
            default: '',
        },
    },
    emits: ['onGoBack'],
    computed: {
        subtitleText(): string {
            return `The QR you scanned does not match your selected trailer (${this.attachingTrailerNumber}). If you want to proceed with a different trailer, please perform a new scan.`;
        },
    },
    methods: {
        goBack(): void {
            this.$emit('onGoBack');
        },
        navigateToEnterTrailer(): void {
            this.$router.push({ name: 'EnterTrailer' });
        },
    },
});
